module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('p', {
    staticClass: "form-group-label"
  }, [_vm._v("Format")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.format),
      expression: "value.format"
    }],
    attrs: {
      "type": "radio",
      "name": "formatRadio",
      "value": "excel"
    },
    domProps: {
      "checked": _vm._q(_vm.value.format, "excel")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "format", "excel")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Excel")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.format),
      expression: "value.format"
    }],
    attrs: {
      "type": "radio",
      "value": "csv"
    },
    domProps: {
      "checked": _vm._q(_vm.value.format, "csv")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "format", "csv")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Csv")])])]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.format),
      expression: "value.format"
    }],
    attrs: {
      "type": "radio",
      "value": "json"
    },
    domProps: {
      "checked": _vm._q(_vm.value.format, "json")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.value, "format", "json")
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Json")])])])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.singleSheet),
      expression: "value.singleSheet"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.value.format !== 'excel'
    },
    domProps: {
      "checked": Array.isArray(_vm.value.singleSheet) ? _vm._i(_vm.value.singleSheet, null) > -1 : (_vm.value.singleSheet)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.singleSheet,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "singleSheet", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "singleSheet", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "singleSheet", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Single sheet for all reports")])])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.createPivots),
      expression: "value.createPivots"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.value.format !== 'excel'
    },
    domProps: {
      "checked": Array.isArray(_vm.value.createPivots) ? _vm._i(_vm.value.createPivots, null) > -1 : (_vm.value.createPivots)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.createPivots,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "createPivots", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "createPivots", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "createPivots", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Create pivot tables")])])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.recursive),
      expression: "value.recursive"
    }],
    attrs: {
      "type": "checkbox",
      "disabled": _vm.value.format !== 'excel'
    },
    domProps: {
      "checked": Array.isArray(_vm.value.recursive) ? _vm._i(_vm.value.recursive, null) > -1 : (_vm.value.recursive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.value.recursive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.value, "recursive", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.value, "recursive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.value, "recursive", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v("Create sheets for sub-sectors")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onDownloadClick
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Download\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19cd2082", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19cd2082"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/download-reports-dialog/download-reports-dialog.vue.html
// module id = 1081
// module chunks = 0